import React from 'react';
import { g_HttpReq } from '../utils/httpUtils';

// /////////////////////////////////////////////////////////////////////////////////////////////
// ApiAdmin /////////////////////////////////////////////////////////////////////////////////////
// /////////////////////////////////////////////////////////////////////////////////////////////

class apiAdmin {
  // /////////////////////////////////////////////////////////////////////////////////////////////
  async apiServicesGet() {
    return g_HttpReq.fetchGetJson('/admin/services', {});
  }

  // /////////////////////////////////////////////////////////////////////////////////////////////
  async apiMqttBrokersGet() {
    return g_HttpReq.fetchGetJson('/admin/mqttBrokers', {});
  }

  // /////////////////////////////////////////////////////////////////////////////////////////////
  async apiMqttBrokersLogGet() {
    return g_HttpReq.fetchGetJson('/admin/mqttBrokers/log', {});
  }

  // /////////////////////////////////////////////////////////////////////////////////////////////
  async apiServicesStatisticsGet() {
    return g_HttpReq.fetchGetJson('/admin/statistics/services', {});
  }

  // /////////////////////////////////////////////////////////////////////////////////////////////
  async apiTripsStatisticsGet(props = {}) {
    return g_HttpReq.fetchGetJson('/admin/statistics/trips', props);
  }

  // /////////////////////////////////////////////////////////////////////////////////////////////
  async apiActivationsStatisticsGet(props = {}) {
    return g_HttpReq.fetchGetJson('/admin/statistics/activations', props);
  }

  // /////////////////////////////////////////////////////////////////////////////////////////////
  async apiMqttClientsGet() {
    return g_HttpReq.fetchGetJson('/admin/mqttClients', {});
  }

  // /////////////////////////////////////////////////////////////////////////////////////////////
  async apiGpsLogGet(props = {}) {
    return g_HttpReq.fetchGetJson('/admin/gpsLog', props);
  }

  // /////////////////////////////////////////////////////////////////////////////////////////////
  async apiDeviceMsgLogGet(props = {}) {
    return g_HttpReq.fetchGetJson('/admin/deviceMsgLog', props);
  }

  // /////////////////////////////////////////////////////////////////////////////////////////////
  async apiDeviceEventLogGet(props = {}) {
    return g_HttpReq.fetchGetJson('/admin/deviceEventLog', props);
  }

  // /////////////////////////////////////////////////////////////////////////////////////////////
  async apiUiErrorCreate(event = {}) {
    return g_HttpReq.fetchPostJson('/admin/uierror', event);
  }

  // /////////////////////////////////////////////////////////////////////////////////////////////
  async apiUiErrorsGet(props = {}) {
    return g_HttpReq.fetchGetJson('/admin/uierror', props);
  }

  // /////////////////////////////////////////////////////////////////////////////////////////////
  async apiServicesLogGet(props = {}) {
    return g_HttpReq.fetchGetJson('/admin/serviceslog', props);
  }

  // /////////////////////////////////////////////////////////////////////////////////////////////
  async apiBillingLogGet(props = {}) {
    return g_HttpReq.fetchGetJson('/admin/billinglog', props);
  }

  // /////////////////////////////////////////////////////////////////////////////////////////////
  async apiAuditLogGet(props = {}) {
    return g_HttpReq.fetchGetJson('/admin/auditlog', props);
  }

  // /////////////////////////////////////////////////////////////////////////////////////////////
  async apiTrackersMsgLogGet(props = {}) {
    return g_HttpReq.fetchGetJson('/admin/trackersmsglog', props);
  }

  // /////////////////////////////////////////////////////////////////////////////////////////////
  async apiTrackerActivityGet(props = {}) {
    return g_HttpReq.fetchGetJson('/admin/trackeractivity', props);
  }

  // /////////////////////////////////////////////////////////////////////////////////////////////
  async apiFleetVideoListGet(props = {}) {
    return g_HttpReq.fetchGetJson('/admin/fleetvideos', props);
  }

  // /////////////////////////////////////////////////////////////////////////////////////////////
  async apiDevsConfigUpdateMD5(props = {}) {
    return g_HttpReq.fetchPostJson('/admin/devicesconfig', props);
  }

  // /////////////////////////////////////////////////////////////////////////////////////////////
  async apiSafetyEventsTriggersGet() {
    return g_HttpReq.fetchGetJson('/admin/safetyevents-triggers', {});
  }

  // /////////////////////////////////////////////////////////////////////////////////////////////
  async apiConfigsUpdate(props = {}) {
    return g_HttpReq.fetchPatchJson('/admin/configs', props);
  }

  // /////////////////////////////////////////////////////////////////////////////////////////////
  async apiConfigsGet(props = {}) {
    return g_HttpReq.fetchGetJson('/admin/configs', props);
  }

  // /////////////////////////////////////////////////////////////////////////////////////////////
  async apiProfileGet(props = {}) {
    const { path, ...rest } = props;
    if (!path) {
      throw new Error('Path is required for apiProfileGet');
    }
    return g_HttpReq.fetchGetFile(path, { ...rest });
  }

  // /////////////////////////////////////////////////////////////////////////////////////////////
  async apiKafkaStatusGet(props = {}) {
    return g_HttpReq.fetchGetJson('/admin/kafka/status', props);
  }

  // /////////////////////////////////////////////////////////////////////////////////////////////
  async apiActiveStatisticsGet(props = {}) {
    return g_HttpReq.fetchGetJson('/admin/statistics/active', props);
  }

  // /////////////////////////////////////////////////////////////////////////////////////////////
  async apiBillingSummaryGet(props = {}) {
    return g_HttpReq.fetchGetJson('/admin/billingsummary', props);
  }

  // /////////////////////////////////////////////////////////////////////////////////////////////
  async apiTopRestartsGet(props = {}) {
    return g_HttpReq.fetchGetJson('/admin/statistics/restarts', props);
  }
}

const g_apiAdmin = new apiAdmin();
export default g_apiAdmin;
